var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-card',{attrs:{"size":"small","title":"在线设备v5"}}),_c('a-card',{attrs:{"size":"small"}},[_c('searchE',{on:{"handleSearch":_vm.handleSubmit}}),_c('tableE',{ref:"templeteTableID"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }